var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"RoundIcon icon is-round",class:_vm.classes},[_c('clipping-type-icon',{class:_vm.iconClass,attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }